module.exports = __webpack_public_path__ + "img/radio-mix.167e1381.svg";